/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Row_MissingInputs */

const en_pwf_row_missing = /** @type {(inputs: Pwf_Row_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a status for these items.`)
};

const de_pwf_row_missing = /** @type {(inputs: Pwf_Row_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle einen Status für diese Vorgänge.`)
};

/**
* | output |
* | --- |
* | "Choose a status for these items." |
*
* @param {Pwf_Row_MissingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_row_missing = /** @type {((inputs?: Pwf_Row_MissingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Row_MissingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_row_missing(inputs)
	return en_pwf_row_missing(inputs)
});